<template>
	<div class="compPinglun">
		<div class="pinglunBox" v-if="tableData.length===0" style="padding-top: 20px;">
			暂无分享人员
		</div>
		<div class="pinglunBox" v-else>
			<el-table :data="tableData" height="100%">
				<el-table-column prop="no" label="序号" width="50">
					<template slot-scope="scope">
						{{scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column label="分享人" >
					<template slot-scope="scope">
						{{scope.row.userName}}
					</template>
				</el-table-column>
				<el-table-column label="分享时间">
					<template slot-scope="scope">
						{{scope.row.createOperationInfo&&scope.row.createOperationInfo.operationTime}}
					</template>
				</el-table-column>
				<el-table-column label="分享方式" >
					<!-- <template slot-scope="scope">
						{{scope.row.column.name}}
					</template> -->
				</el-table-column>
			</el-table>
		</div>
		<div class="pagePosi">
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	export default {
		components:{page},
		data() {
			return {
				
				// 列表
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				tableData:[],
			}
		},
		computed:{
			
		},
		props:{
			contentId:{
				default:'',
			},
			contentType:{
				default:'',
			}
		},
		created(){
			
		},
		mounted(){
			this.getTableData();
		},
		methods:{
			// 获取评论
			changePage(num){
				this.page.page=num;
				this.getTableData()
			},
			getTableData(){
				let type = 0
				if(this.contentType==='商品'){ type=1 }
				else if(this.contentType==='活体'){ type=2 }
				else if(this.contentType==='文章'){ type=3 }
				else if(this.contentType==='动态'){ type=4 }
				else if(this.contentType==='评论'){ type=5 }
				else if(this.contentType==='口碑'){ type=6 }
				let params = {
					"keyWord":'',
					"sort": "",
					"desc": true,
					"type": type, // 1 商品 2 活体 3 文章 4 动态
					"paramId": this.contentId, // 收藏对应的id
					"userId": '', // 用户id
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
				}
				let loading = this.$loading()
				this.$http.post(process.env.VUE_APP_AppAdmin+'/api/UserCollect/GetUserCollectList', params).then(res => {
					loading.close();
					if (res.code == 0) {
						this.page.total = res.data.count;
						this.tableData = res.data.list;
					}
				})
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.compPinglun{
		.pinglunLine{
			display: flex;height: 76px;padding:24px 0 10px 0;
			.pinglunPic{
				width:56px;height: 56px;border-radius: 50%;margin-right: 24px;margin-top:12px;
			}
			.pinglun{
				width:550px;
			}
			.pinglunBtn{
				border-radius: 8px;width:76px;background-color: #577BFF;text-align: center;font-size: 16px;cursor: pointer;color:#fff;line-height: 24px;padding-top:14px;margin-left: 16px;
			}
		}
		.pinglunNav{
			display: flex;justify-content:space-between;padding-top:20px;
			.pinglunNavL{
				display: flex;justify-content: flex-end;
				.pinglunNavItem{
					font-size: 14px;color:$color333;border-right: 1px solid #B0B0BF;padding:0 16px;font-weight: 600;cursor: pointer;
					&.active{
						color:#577BFF;
					}
				}
			}
			.pinglunNavR{
				
			}
		}
		.pinglunBox{
			border-radius: 8px;background-color: #F7F7FA;border:1px solid #F2F2F2;margin-top: 16px;padding:16px;
			.wordItem{
				display: flex;padding-top:24px;
				.wordItemL{
					width:44px;flex-shrink: 0;
					.wordItemAvatar{
						width:36px;height: 36px;border-radius: 50%;
					}
				}
				.wordItemR{
					width:100%;border-bottom: 1px solid #D8D8D8;padding-bottom:24px;
					.wordMsgLine{
						display: flex;justify-content: space-between;padding: 2px 0 6px 0;
						.wordPeople{
							font-size: 14px;color:#666;
						}
						.wordState{
							display: flex;
							.wordStateItem{
								font-size: 14px;color:$color333;margin-left:32px;
							}
						}
					}
					.wordContentLine{
						font-size: 14px;color:#333;padding-right: 230px;line-height: 20px;
					}
					.wordTimeLine{
						display: flex;padding-top:16px;
						.num1{
							font-size: 14px;color:#333;margin-right: 16px;
						}
						.num2{
							font-size: 14px;color:$color999;margin-right: 32px;
						}
						.btn{
							font-size: 14px;color:#577BFF;margin-right: 32px;cursor: pointer;
						}
					}
				}
				.wordMore{
					font-size: 14px;color:#999999;cursor: pointer;padding: 10px 0 0 0;
				}
			}
		}
		.pagePosi{
			text-align: right;
		}
		.drawer_pinglun{
			
		}
	}
</style>